import React from 'react'
import { useState } from 'react';
import Peshbiniakan from '../data/peshbibiakan.json';
import Games from '../data/games.json';
import { useSelector } from 'react-redux'
import { HiCheck } from "react-icons/hi";
import { Toast } from 'flowbite-react';



export default function Peshbinibka(props) {


    const id = props.index - 1
 

    const [toast, setToast] = useState()

    function Toastt() {
        setToast(<Toast className=''>
            <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-green-100 text-green-500 ">
                <HiCheck className="h-5 w-5" />
            </div>
            <div className="ml-3 text-sm font-normal">
                پێشبینیەکەت سەرکەوتووبوو
            </div>
            <Toast.Toggle />
        </Toast>)
    }



    const [in1, setin1] = useState('0');
    const [in2, setin2] = useState('0');
   
    const val = (e) => {
        setin1(e.target.value)
    }

    const val2 = (e) => {
        setin2(e.target.value)
    }
   
    function hh(e) {



      
        Peshbiniakan.push(peshbiniaka)
        localStorage.setItem('peshbiniakan', JSON.stringify(Peshbiniakan));

    }
    const user = useSelector((state) => state.user)

    const peshbiniaka = {

        "id": `${Games[id].id}`,
        "username": `${user.userName}`,
        "userImage": `${user.userImage}`,
        "gametype": `${Games[id].gametype}`,
        "team1": `${Games[id].team1}`,
        "team2": `${Games[id].team2}`,
        "logot1": `${Games[id].logot1}`,
        "logot2": `${Games[id].logot2}`,
        "peshT1": `${in1}`,
        "peshT2": `${in2}`,
        "date": `${Games[id].date}`,
        "time": `${Games[id].time}`,
        "result": `${in1}-${in2}`
    }
    


    const [disable, setDisable] = useState(false);

    const [warnning, setWarnning] = useState(
        <div id="alert-4" class="flex p-4 mb-4 bg-yellow-100 rounded-lg " role="alert">
            <svg aria-hidden="true" class="flex-shrink-0 w-5 h-5 text-yellow-700 " fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
            <span class="sr-only">Info</span>
            <div class="ml-3 text-sm font-medium text-center text-yellow-700 ">
                تکایە ئاگاداربە تەنها دەتوانی یەکجار پێشبینیبکەیت <br/> 
                بۆ هەریاریەک بۆیە دڵنیا ببەرەوەلە پێشبینیەکەت
            </div>
            <button onClick={()=>{setWarnning(null)}} type="button" class="ml-auto -mx-1.5 -my-1.5 bg-yellow-100 text-yellow-500 rounded-lg focus:ring-2 focus:ring-yellow-400 p-1.5 hover:bg-yellow-200 inline-flex h-8 w-8 " data-dismiss-target="#alert-4" aria-label="Close">
                <span class="sr-only">Close</span>
                <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
            </button>
        </div>
    )

    return (
        
        <div className='bg-black fixed backdrop-blur-md bg-opacity-5 z-20 w-full bottom-0 top-0 right-0 left-0 flex flex-col p-[51px] items-center space-y-3 '>
            <div className='p-4 rounded-md'>
                <div className='flex  flex-row space-x-3 text-center border-b-[1px] md:text-xl uppercase border-penjam rounded-t-lg p-4 justify-center text-chwaram bg-yakam font-bold' >
                    <img src={Games[id].logot1} alt='' /> <div className='flex items-center space-x-2'>   <p>{Games[id].team1}</p> <p className='text-c7 text-3xl'>VS </p> <p>{Games[id].team2}</p>   </div> <img src={Games[id].logot2} alt='' />
                </div>
                <form className='bg-dwam rounded-b-lg shadow-xl p-3' action='/p'>

                    <label className="block uppercase text-center p-2 drop-shadow-lg mb-2 text-2xl font-medium text-shasham ">
                        {user.userName}
                    </label>
                   


                    <label for="small-input" className="block mb-5 border-b-[1px] border-penjam text-sm font-medium text-shasham ">PESHBINI</label>

                    <div className=' flex item-center text-center justify-center space-x-3'>

                        <div>
                            <label for="small-input" className="block mb-1 text-xs font-medium text-shasham ">
                                {Games[id].team1}
                            </label>
                            <input onChange={val} type="number" min={0} id="small-input" class="block p-2 w-28 text-seyam bg-yakam rounded-lg border border-penjam sm:text-xs " required />
                        </div>

                        <div className='flex text-gray-400 items-end font-bold'>
                            <p> VS </p>
                        </div>

                        <div>
                            <label for="small-input" className="block mb-1 text-xs font-medium text-shasham ">
                                {Games[id].team2}
                            </label>
                            <input onChange={val2} type="number" min={0} id="small-input" className="block p-2 w-28 text-seyam bg-yakam rounded-lg border border-penjam sm:text-xs " required />
                        </div>

                    </div>

                    <div>
                        
                        <button disabled={disable} onClick={() => { hh(); Toastt(); setDisable(true) }} type="button" className="shadow-sm mt-3 shadow-penjam relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 w-full overflow-hidden text-sm font-medium text-seyam rounded-lg group bg-gradient-to-br from-penjam to-shasham group-hover:from-penjam group-hover:to-shasham hover:text-black  focus:ring-4 focus:outline-none focus:ring-green-200 ">
                            <span className="shadow-sm text-center shadow-penjam relative w-full px-5 py-2.5 transition-all ease-in duration-200 bg-yakam  rounded-md group-hover:bg-opacity-0">
                                پێشبینی بکە
                            </span>
                        </button>

                    </div>
                </form>
            </div>
            <div>
                {warnning}
                {toast}
            </div>
        </div>

    )


}
